/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamItemsIdCancel202,
  PostApiV1ExamItemsIdCancel401,
  PostApiV1ExamItemsIdCancel404,
  PostApiV1ExamItemsIdCancel500,
  PostApiV1ExamItemsIdCancelMutationRequest,
  PostApiV1ExamItemsIdCancelMutationResponse,
  PostApiV1ExamItemsIdCancelPathParams,
} from "../../types/examEvaluationController/PostApiV1ExamItemsIdCancel.ts";
import { examItemCancelRequestViewModelSchema } from "../examItemCancelRequestViewModelSchema.ts";

export const postApiV1ExamItemsIdCancelPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1ExamItemsIdCancelPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamItemsIdCancel202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamItemsIdCancel202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamItemsIdCancel401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamItemsIdCancel401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamItemsIdCancel404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamItemsIdCancel404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamItemsIdCancel500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamItemsIdCancel500>;

export const postApiV1ExamItemsIdCancelMutationRequestSchema = z.lazy(
  () => examItemCancelRequestViewModelSchema,
) as unknown as ToZod<PostApiV1ExamItemsIdCancelMutationRequest>;

export const postApiV1ExamItemsIdCancelMutationResponseSchema = z.lazy(
  () => postApiV1ExamItemsIdCancel202Schema,
) as unknown as ToZod<PostApiV1ExamItemsIdCancelMutationResponse>;
